module.exports = __webpack_public_path__ + "img/t1-mimosa.46fa3e86.jpg";